import React, { lazy } from "react";

const LazyChatAgent = lazy(() => import("./ChatAgent"));

const ChatAgent = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyChatAgent {...props} />;

export default ChatAgent;
